<div class="login-Wrapper">
  <div class="login login-select">
    <h2 class="title-3 text-center">
      {{ "Join us" | translate }}
    </h2>

    <h4 class="login-hint">
      {{ "I want to register as" | translate }}
    </h4>

    <!-- choicesCards ## START ## -->
    <div class="login-choicesCards">
      <div class="row">
        <div class="col-6" (click)="onSelect('MEMBER')">
          <!-- choiceCard ## START ## -->
          <div class="choiceCard">
            <input
              type="radio"
              class="choiceCard-input"
              name="choice"
              id="ChoiceCard1"
            />
            <label class="choiceCard-body" for="ChoiceCard1">
              <span class="choiceCard-icon">
                <img
                  src="../../../assets/images/login/header-type-user.png"
                  alt=""
                  class="image"
                />
              </span>
              <span class="choiceCard-title">
                {{ "Member" | translate }}
              </span>
            </label>
          </div>
          <!-- choiceCard ## END ## -->
        </div>
        <div class="col-6" (click)="onSelect('COMPANY')">
          <!-- choiceCard ## START ## -->
          <div class="choiceCard">
            <input
              type="radio"
              class="choiceCard-input"
              name="choice"
              id="ChoiceCard2"
            />
            <label class="choiceCard-body" for="ChoiceCard2">
              <span class="choiceCard-icon">
                <img
                  src="../../../assets/images/login/header-type-company.png"
                  alt=""
                  class="image"
                />
              </span>
              <span class="choiceCard-title">
                {{ "organization company" | translate }}
              </span>
            </label>
          </div>
          <!-- choiceCard ## END ## -->
        </div>
      </div>
    </div>
    <!-- choicesCards ## END ## -->
    <!--    -->
    <button
      [routerLink]="['../signup']"
      [queryParams]="{ type: selectedType }"
      class="btn login-nextBtn"
      [disabled]="!selectedType"
    >
      <i class="fas icon"></i>
      <span class="text">
        {{ "next" | translate }}
      </span>
    </button>

    <button [routerLink]="['../login']" class="btn btn-primary w-100 mb-3">
      {{ "Log in" | translate }}
    </button>
  </div>
</div>
